import { type ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useComposerState } from '../hooks/use-composer-state';
import { ComposerEditorSide } from './composer-editor-side';
import { ComposerPreview } from './composer-preview';
import type { Comunicado } from '../types-comunicados';

const BACK =
  'flex items-center gap-xs text-xs text-text-tertiary hover:text-text-secondary';
const TITLE = 'font-display text-lg font-bold text-text-primary';

export function ComposerHeader(p: {
  onBack: () => void;
  title: string;
}): ReactNode {
  return (
    <div className="space-y-sm">
      <button type="button" onClick={p.onBack} className={BACK}>
        <ArrowLeft size={12} /> Volver
      </button>
      <h1 className={TITLE}>{p.title}</h1>
    </div>
  );
}

export function ComposerGrid(props: {
  data: ReturnType<typeof useComposerState>['data'];
  update: ReturnType<typeof useComposerState>['update'];
  existing: Comunicado | undefined;
  authorLabel: string;
  onMediaChanged: () => void;
}): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-lg lg:grid-cols-[1fr_360px]">
      <ComposerEditorSide
        data={props.data}
        onUpdate={props.update}
        comunicadoId={props.existing?.id}
        mediaFiles={props.existing?.media || []}
        onMediaChanged={props.onMediaChanged}
      />
      <ComposerPreview
        data={props.data}
        existing={props.existing}
        authorLabel={props.authorLabel}
      />
    </div>
  );
}
